import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Chip,
  Box,
  Typography,
} from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import EditIcon from '@mui/icons-material/Edit';

const getDisplayStatus = (status) => {
  switch (status) {
    case 'Purchased':
      return 'Available';
    case 'Not Purchased':
      return 'Not Available';
    case 'Lucy':
      return 'Owned';
    default:
      return status;
  }
};

export default function StuffedAnimalList({ stuffedAnimals, onToggleWanted, loadingToggles, isAdmin, onEdit, getImageUrl }) {
  const isBirthday = (birthday) => {
    if (!birthday || birthday === 'Unknown') return false;
    
    const today = new Date();
    const [month, day] = birthday.split(' ');
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    
    return months[today.getMonth()] === month && today.getDate().toString() === day;
  };

  return (
    <List>
      {stuffedAnimals.map((animal) => (
        <ListItem
          key={animal._id}
          divider
          sx={{
            '&:hover': {
              bgcolor: 'action.hover',
            },
          }}
        >
          <Box
            component="img"
            src={getImageUrl(animal.imageUrl)}
            alt={animal.name}
            sx={{
              width: 60,
              height: 60,
              objectFit: 'contain',
              mr: 2,
              bgcolor: 'background.paper',
            }}
          />
          <ListItemText
            primary={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="subtitle1">{animal.name}</Typography>
                <Chip
                  label={getDisplayStatus(animal.status)}
                  size="small"
                  color={
                    animal.status === 'Lucy'
                      ? 'success'
                      : animal.status === 'Purchased'
                      ? 'info'
                      : 'default'
                  }
                />
                {animal.wanted && (
                  <Chip label="Wanted" size="small" color="primary" />
                )}
              </Box>
            }
            secondary={
              <Box sx={{ mt: 0.5 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  {animal.description}
                </Typography>
                <Typography
                  variant="body2"
                  color={isBirthday(animal.birthday) ? 'success.main' : 'text.secondary'}
                  sx={{ fontWeight: isBirthday(animal.birthday) ? 'bold' : 'normal' }}
                >
                  Birthday: {animal.birthday || 'Unknown'}
                  {isBirthday(animal.birthday) && ' 🎂'}
                </Typography>
              </Box>
            }
          />
          <ListItemSecondaryAction>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {isAdmin && (
                <>
                  <IconButton
                    edge="end"
                    onClick={() => onToggleWanted(animal._id)}
                    disabled={loadingToggles.has(animal._id)}
                    color="primary"
                  >
                    {animal.wanted ? <FavoriteIcon /> : <FavoriteBorderIcon />}
                  </IconButton>
                  <IconButton
                    edge="end"
                    onClick={() => onEdit(animal._id)}
                    color="primary"
                  >
                    <EditIcon />
                  </IconButton>
                </>
              )}
              {!isAdmin && animal.wanted && (
                <FavoriteIcon color="primary" />
              )}
              {!isAdmin && !animal.wanted && (
                <FavoriteBorderIcon color="disabled" />
              )}
            </Box>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
} 